<script setup lang="ts">
  import { useLayout } from "@/layout/composables/layout"
  import { ref } from "vue"
  import AppBreadcrumb from "./AppBreadcrumb.vue"

  const { onMenuToggle } = useLayout()

  // Toggle dark mode
  const isDark = ref(document.documentElement.classList.contains("dark"))
  const toggleDark = () => {
    isDark.value = !isDark.value
    document.documentElement.classList.toggle("dark", isDark.value)
    localStorage.setItem("theme", isDark.value ? "dark" : "light")
  }
  // Initialisation : restaurer le choix utilisateur
  if (localStorage.getItem("theme") === "dark") {
    isDark.value = true
    document.documentElement.classList.add("dark")
  }
</script>

<template>
  <div class="layout-topbar">
    <div class="topbar-start">
      <Button
        type="button"
        class="topbar-menubutton p-trigger"
        @click="onMenuToggle">
        <i class="pi pi-bars"></i>
      </Button>
      <img
        :src="
          isDark
            ? '/images/FDC_Logo_slogan_blanc.svg'
            : '/images/FDC_Logo_slogan_noir.svg'
        "
        style="width: 220px !important ; height: 40px !important"
        class="block lg:hidden" />
      <AppBreadcrumb class="topbar-breadcrumb"></AppBreadcrumb>
    </div>

    <div class="topbar-end flex items-center gap-4">
      <button
        @click="toggleDark"
        :aria-pressed="isDark"
        class="ml-2 w-10 h-10 flex items-center justify-center rounded-full border border-gray-300 dark:border-gray-700 bg-white/80 dark:bg-gray-900/80 shadow transition-all duration-300 hover:scale-105 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
        title="Basculer mode sombre/clair">
        <span class="relative flex items-center justify-center w-6 h-6">
          <i
            v-if="!isDark"
            class="pi pi-sun text-xl transition-transform duration-300"></i>
          <i
            v-else
            class="pi pi-moon text-gray-200 text-xl transition-transform duration-300"></i>
        </span>
      </button>
    </div>
  </div>
</template>
